module.exports = __webpack_public_path__ + "img/Pfade_Tabea_11.5cbf04d3.png";